export default "__VITE_ASSET__AXvv5yxh__"